import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function RatingDialog({ booking, open, onOpenChange, onSubmitted }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  if (!booking) return null;
  const otherName = booking.other_user_name || "l'utilisateur";
  const isHostRating = booking.owner_id === booking.viewer_id;
  const title = isHostRating ? `Évaluer le campeur : ${otherName}` : `Évaluer l'hôte : ${otherName}`;

  const submit = async () => {
    if (rating < 1) { toast.error("Sélectionnez une note"); return; }
    setLoading(true);
    try {
      await api.post("/ratings", { booking_id: booking.id, rating, comment });
      toast.success("Évaluation envoyée!");
      onSubmitted?.();
      onOpenChange(false);
      setRating(0); setComment(""); setHover(0);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl" data-testid="rating-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{title}</DialogTitle>
          <DialogDescription>Votre avis sera publié quand {otherName} aura évalué à son tour, ou après 7 jours.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex items-center justify-center gap-1" data-testid="rating-stars">
            {[1,2,3,4,5].map(n => (
              <button
                key={n}
                type="button"
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                onClick={() => setRating(n)}
                className="p-1 transition-transform hover:scale-110"
                data-testid={`rating-star-${n}`}
              >
                <Star className={`h-10 w-10 ${(hover || rating) >= n ? "fill-amber-400 text-amber-400" : "text-zinc-300"}`} />
              </button>
            ))}
          </div>
          <div>
            <Textarea
              value={comment}
              onChange={e => setComment(e.target.value)}
              placeholder="Un mot pour partager votre expérience (optionnel)"
              className="rounded-xl min-h-[90px]"
              maxLength={500}
              data-testid="rating-comment"
            />
            <p className="text-xs text-zinc-400 mt-1 text-right">{comment.length}/500</p>
          </div>
          <Button
            onClick={submit}
            disabled={loading || rating < 1}
            className="w-full bg-emerald-700 text-white hover:bg-emerald-800 rounded-xl h-11"
            data-testid="rating-submit-btn"
          >
            {loading ? "Envoi..." : "Envoyer l'évaluation"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
